var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from 'react';
import { FormBase, XbpmContext, SCROLL_TO_ERROR } from '@unitarius/xbpm-runtime';
import { injector, FORM_HANDLER_FACTORY_TOKEN } from '../common';
import { equals } from 'ramda';
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form(props) {
        var _this = _super.call(this, props) || this;
        _this.formHandler = injector.get(FORM_HANDLER_FACTORY_TOKEN)();
        return _this;
    }
    Form.prototype.blockBrowserBackForwardNavigation = function () {
        // a hack to stop browser back and forward buttons navigation
        // https://stackoverflow.com/questions/12381563/how-can-i-stop-the-browser-back-button-using-javascript
        var _hash = '!';
        window.location.href += '#';
        setTimeout(function () { return (window.location.href += '!'); }, 50);
        window.onhashchange = function () { return window.location.hash !== _hash && (window.location.hash = _hash); };
        document.body.onkeydown = function (e) {
            var elm = e.target && e.target.nodeName.toLowerCase();
            if (e.keyCode === 8 && elm !== 'input' && elm !== 'textarea') {
                e.preventDefault();
            }
            // Stopping the event bubbling up the DOM tree...
            // e.stopPropagation();
        };
    };
    Form.prototype.componentDidMount = function () {
        var $kind = this.props.params.$kind;
        // block back and forward browser buttons when app initial start is in business process
        if ($kind === 'task') {
            this.blockBrowserBackForwardNavigation();
        }
    };
    Form.prototype.componentDidUpdate = function (prevProps) {
        // xbpm instance params change
        if (!equals(prevProps.params, this.props.params)) {
            // block back and forward browser buttons when in business process
            // case 0: url replace after process starts by key
            if (prevProps.params['$kind'] === 'process' && this.props.params['$kind'] === 'task') {
                this.blockBrowserBackForwardNavigation();
            }
            // case 1: form change within business process
            if (prevProps.params['$kind'] === 'task' && this.props.params['$kind'] === 'task') {
                if (prevProps.params.taskDefinitionKey !== this.props.params.taskDefinitionKey) {
                    this.blockBrowserBackForwardNavigation();
                }
            }
        }
    };
    Form.prototype.componentWillUnmount = function () {
        this.formHandler.destroy();
    };
    Form.prototype.render = function () {
        return React.createElement(FormBase, __assign({}, this.props, { formHandler: this.formHandler, onValidationErrorsHighlight: this.scrollToError }));
    };
    Form.prototype.scrollToError = function (errors) {
        // emit event with errors data
        XbpmContext.getContext().emit(SCROLL_TO_ERROR, errors);
        var consoleErrors = [];
        for (var _i = 0, _a = Object.entries(errors); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            consoleErrors.push({ fieldId: key, element: document.getElementById(key), message: value });
        }
        console.warn('Invalid fields', consoleErrors);
        var invalidElement = document.getElementById(Object.keys(errors)[0]);
        var scrollToElement = (invalidElement && invalidElement.parentElement) || invalidElement;
        if (scrollToElement) {
            scrollToElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
    };
    return Form;
}(PureComponent));
export { Form };
//# sourceMappingURL=Form.js.map